import React from "react";
import "./BesmartBotAnim.css";
import { Box, Container } from "@mui/material";
import BesmartLogo from "./BesmartLogo";
import PulsingCircle from "./PulsingCircle";

const BesmartAnimation = () => {
  return (
    <Container sx={{
			paddingTop: "100px",
			paddingBottom: "100px",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			position: "relative",
		}}>
			<BesmartLogo />
			<PulsingCircle size={193} delay={0} />
			<PulsingCircle size={193} delay={0.8} />
			<PulsingCircle size={193} delay={1.6} />
			<PulsingCircle size={193} delay={2.4} />
    </Container>
  );
};

export default BesmartAnimation;
